<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">
        {{TR "Webhook konfigurieren"}}
    </h4>
</div>
<div class="modal-body">
    {{ERROR_ROW errors.error}}
    {{#WIZARD wizardContext}}
         <!-- Page 1 -->
        {{#WIZARD-TAB 'Ereignisse'}}
            {{#if noEventsSelectable}}
            <div class="alert alert-info m-b-20">{{TR "Aktuell können keine Ereignisse ausgewählt werden."}}</div>
            {{TR "Ereignisse die über einen Webhook weitergegeben werden können, sind beispielsweise Alarme die für ein Postfach konfiguriert sind."}}
            {{else}}
            {{#SELECT formData.webhook_events}}
                <select multiple="multiple" class="multi-select" id="group_multi_select" name="groups">
                    {{#if can_see_type1}}
                    <optgroup label="{{TR "Alarm ausgelöst"}}">
                        {{#each alarmList}}
                            <option value="{{id}}_1">{{name}}</option>
                        {{/each}}
                    </optgroup>
                    {{/if}}

                    {{#if can_see_type2}}
                    <optgroup label="{{TR "Alarm aufgehoben"}}">
                        {{#each alarmList}}
                            <option value="{{id}}_2">{{name}}</option>
                        {{/each}}
                    </optgroup>
                    {{/if}}

                    {{#if can_see_type3}}
                    <optgroup label="{{TR "Alarm quittiert"}}">
                        {{#each alarmList}}
                            <option value="{{id}}_3">{{name}}</option>
                        {{/each}}
                    </optgroup>
                    {{/if}}

                    {{#if can_see_type4}}
                    <optgroup label="{{TR "Alarm gelöscht"}}">
                        {{#each alarmList}}
                            <option value="{{id}}_4">{{name}}</option>
                        {{/each}}
                    </optgroup>
                    {{/if}}
                </select>
            {{/SELECT}}
            {{/if}}
        {{/WIZARD-TAB}}
        <!-- Page 2 -->
        {{#WIZARD-TAB 'Webhook'}}
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label for="name" class="control-label" >{{TR "Name"}}</label>
                        <input type="text" maxlength="128" class="form-control {{#if errors.name}}parsley-error{{/if}}" id="name-input"
                               name="name" placeholder="{{TR "Bezeichnung des Webhooks"}}" value="{{formData.name}}">
                        {{#if errors.name}}
                            <ul class="parsley-errors-list filled" id="js-name-error">
                                <li class="parsley-required">{{TR errors.name}}</li>
                            </ul>
                        {{/if}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-10">
                    <div class="form-group">
                        <label for="name" class="control-label">{{TR "URL"}}</label>
                        <input type="text" maxlength="1024" {{#if isUpdated}} disabled {{/if}} class="form-control {{#if errors.url}}parsley-error{{/if}}" id="url-input"
                               name="url" placeholder="{{TR "Webhook URL"}}" value="{{formData.url}}">
                        {{#if errors.url}}
                            <ul class="parsley-errors-list filled" id="js-name-error">
                                <li class="parsley-required">{{TR errors.url}}</li>
                            </ul>
                        {{/if}}
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <div class="btn btn-white m-t-25 pull-right" id="trywebhookurl" name="trywebhookurl">{{TR "Test"}}&nbsp;&nbsp;{{#if urlTestSucceeded}}<icon class="fa fa-check success" />{{/if}}{{#if urlTestFailed}}<icon class="fa fa-exclamation-triangle error" />{{/if}}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="key" class="control-label">{{TR "Auth. Header Name"}}</label>
                        <input type="text" maxlength="256" class="form-control {{#if errors.key}}parsley-error{{/if}}" id="key-input"
                               name="key" placeholder="{{TR "Auth. Header Name"}} ({{TR "optional"}})" value="{{formData.key}}">
                        {{#if errors.key}}
                            <ul class="parsley-errors-list filled" id="js-key-error">
                                <li class="parsley-required">{{TR errors.key}}</li>
                            </ul>
                        {{/if}}
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="val" class="control-label">{{TR "Auth. Header Wert"}}</label>
                        <input type="password" maxlength="2048" class="form-control {{#if errors.val}}parsley-error{{/if}}" id="val-input"
                               name="val" placeholder="{{TR "Auth. Header Wert"}} ({{TR "optional"}})" value="{{formData.val}}">
                        {{#if errors.val}}
                            <ul class="parsley-errors-list filled" id="js-val-error">
                                <li class="parsley-required">{{TR errors.val}}</li>
                            </ul>
                        {{/if}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <div class="checkbox checkbox-primary">
                            <input type="checkbox" id="active" name="active" {{#if formData.active}}checked="checked"{{/if}}>
                            <label for="active">{{TR "Aktiv"}}</label><br>
                        </div>
                    </div>
                </div>
            </div>
        {{/WIZARD-TAB}}
   {{/WIZARD}}
</div>
<div class="modal-footer">{{{WIZARD-BUTTONS wizardContext}}}</div>

